module.exports = __webpack_public_path__ + "img/gala-feedback.731bc37e.svg";